import { render, staticRenderFns } from "./NodeFooterEditor.vue?vue&type=template&id=61e9aae1&scoped=true&"
import script from "./NodeFooterEditor.vue?vue&type=script&lang=js&"
export * from "./NodeFooterEditor.vue?vue&type=script&lang=js&"
import style0 from "./NodeFooterEditor.vue?vue&type=style&index=0&id=61e9aae1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e9aae1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
installComponents(component, {
  VIcon,
  VList,
  VListTile,
  VListTileTitle,
  VMenu,
})
